import {
  Text,
  TwAccordion as Accordion,
} from "@virkesborsen/ui-component-library";

const faqData = [
  {
    question: "Vilka betalningsmetoder stödjer ni?",
    answer:
      "Du kan betala via Klarna eller faktura, vilket kan väljas när du går igenom processen för betalning på vår plattform.",
  },
  {
    question: "Vad är ett ortofoto?",
    answer:
      "Ett ortofoto är ett högupplöst flygfoto taget med drönare, som ger en exakt och aktuell bild av din skog från ovan. Till skillnad från satellitbilder är ortofoton mycket mer detaljerade och visar skogen precis som den ser ut - där träd, stigar, hyggen och andra detaljer framträder tydligt.",
  },
  {
    question: "Vad är ett ortofoto bra för?",
    answer:
      "Med en drönaranalys får du en tydlig överblick över hela din skogsfastighet i detalj – vilket gör det enklare att planera och följa upp ditt skogsbruk. Du kan uppdatera din skogsbruksplan med hög precision, utan att behöva gå ut i fält. Det gör det också lättare att planera smarta åtgärder, både inför och efter insatser som röjning, gallring, avverkning eller återplantering. Samtidigt sparar du både tid och pengar genom att slippa tidskrävande fältarbete i svår terräng.",
  },
  {
    question: "Hur gör man skadeinventering med hjälp av drönare?",
    answer:
      "Du kan välja att lägga till en skadeinventering till ditt ortofoto. Bilderna kommer då att analyseras för att identifiera exempelvis toppbrott eller angrepp från granbarkborre. Dessa områden kommer att vara utmarkerade, vilket gör det lätt för dig att se, undersöka och agera.",
  },
  {
    question: "Fördelar med skadeinventering med drönare?",
    answer:
      "Med hjälp av skadeanalys från drönare kan du upptäcka skador i tid – som granbarkborreangrepp som annars riskerar att sprida sig snabbt. Du får en tydlig bild av hur väderförhållanden påverkat skogen, till exempel genom toppbrott och snöskador efter stormar eller tungt snöfall. Det gör det lättare att prioritera rätt områden och rikta insatserna dit de gör störst nytta. Med en visuell rapport över skadeläget kan du agera proaktivt och planera åtgärder innan problemen växer sig stora – vilket sparar både resurser och skyddar virkesvärdet.",
  },
  {
    question: "Vad får jag om jag köper Skadeinventering Bas?",
    answer:
      "Denna analys går igenom din skog och markerar alla områden där det finns tecken på angrepp av granbarkborre. Alla områden kommer att vara tydligt markerade i din digitala skogsbruksplan så att du kan undersöka vidare.",
  },
  {
    question: "Vad får jag om jag köper Skadeinventering Plus?",
    answer:
      "I detta paket ingår, utöver skadeinventering för granbarkborre, även en inventering för toppbrott. Toppbrott och snöbrott är när toppen av träden har gått av, ofta på grund av kombinationer av stark vind och tung snö på toppen. Har du toppbrott i din skog bör du undersöka om det kräver en åtgärd, som exempelvis en gallring eller avverkning.",
  },
  {
    question: "Vad är ett snöbrott och vad borde jag veta om det?",
    answer:
      "Snöbrott är en sorts toppbrott som uppstår när tung, blöt snö samlas i träden, ofta i kombination med kyla och blåst. Det är främst unga och täta bestånd som drabbas, särskilt på höjder och i vindutsatta lägen. Tall är extra känslig, medan gran och björk ofta klarar sig bättre. Skadorna kan påverka både tillväxt och virkesvärde, och därför är det viktigt att sköta skogen med rätt röjning och gallring i tid. Efter ett snöfall bör du kontrollera skogen, särskilt där du nyligen gjort åtgärder. Om du hittar skador behöver de tas om hand snabbt för att undvika värdeförluster och angrepp från insekter.",
  },
  {
    question: "Kan jag köpa enbart en skadeanalys och inte ortofoto?",
    answer:
      "Nej, då analysen görs baserat på ortofotot så behöver du alltid köpa ett ortofoto. Olika analyser köps därefter som tillägg.",
  },
  {
    question:
      "Finns det några restriktioner gällande vilka som kan köpa en drönarflygning?",
    answer:
      "Ja, det krävs att drönarpiloten kan ta sig till fastigheten samt att det är tillåtet att flyga med drönare i området. Det är alltså inte möjligt att köpa en drönarflygning om din fastighet ligger på en ö eller i ett militärt område. Du måste även vara ägare till fastigheten eller ha tillstånd från ägaren.",
  },
  {
    question: "Var kan jag vända mig om jag har fler frågor?",
    answer:
      "Du är välkommen att kontakta oss på info@treebula.se så återkommer vi så snabbt vi kan.",
  },
];

export default function DroneFAQ() {
  return (
    <div className="w-full bg-white">
      <div className="max-w-[1320px] mx-auto flex flex-col">
        <section className="flex flex-col gap-8 mx-auto p-4 lg:flex-row lg:p-16 ">
          <div className="lg:w-1/3">
            <Text
              variant="displayAndHeadlineSmall"
              className="text-charcoal-500 text-[56px] font-bold mb-4"
            >
              FAQ
            </Text>
            <Text
              variant="sectionHeaderMedium"
              className="text-charcoal-500 text-lg"
            >
              Få svar på vanliga frågor, hjälp och vägledning när du säljer
              virke.
            </Text>
          </div>

          <div className="lg:w-2/3">
            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <Accordion key={index} tw>
                  <Accordion.Header
                    tw
                    className="flex items-center gap-3 w-full"
                  >
                    <Text
                      variant="text-sm/leading-normal/medium"
                      className="text-charcoal-500"
                    >
                      {faq.question}
                    </Text>
                  </Accordion.Header>
                  <Accordion.Content tw>
                    <Text
                      variant="text-sm/leading-normal/medium"
                      className="text-charcoal-500"
                    >
                      {faq.answer}
                    </Text>
                  </Accordion.Content>
                </Accordion>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
